import { NgClass } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { ToastService } from '../../../core/services/toast.service';
import { TranslateModule } from '@ngx-translate/core';
@Component({
  selector: 'app-custom-snackbar',
  imports: [MatIconModule, NgClass, TranslateModule],
  templateUrl: './custom-snackbar.component.html',
  styleUrl: './custom-snackbar.component.scss'
})
export class CustomSnackbarComponent {
data = inject<{
    icon: string;
    message: string;
}>(MAT_SNACK_BAR_DATA);

toastService = inject(ToastService);

get chatSupportMessage(): { before: string; linkText: string; url: string; after: string } | null {
  const match = this.data.message.match(/^(.*)\[([^\]]+)\]\((https?:\/\/[^)]+)\)(.*)$/);
  return match
    ? { before: match[1], linkText: match[2], url: match[3], after: match[4] }
    : null;
}

closeSnackBar() {
  this.toastService.snackBarRef.dismiss();
}
}
